import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root'
})
export class QuotationsService {

  constructor(private http: HttpClient) { }

  saveQuotations(data) {
    return this.http.put(
      `${environment.apiHost}/v1/quotation`,
      data
    );
  }

  updateQuotations(data) {
    return this.http.patch(
      `${environment.apiHost}/v1/quotation`,
      data
    );
  }

  get(data) {
    return this.http.post(
      `${environment.apiHost}/v1/quotation`,
      data
    );
  }

  getEnterprises(data) {
    return this.http.post(
      `${environment.apiHost}/v1/vendor`,
      data
    );
  }

  closeQuotations(data) {
    return this.http.patch(
      `${environment.apiHost}/v1/quotation/close`,
      data
    );
  }

  sendEmail(data) {
    return this.http.patch(
      `${environment.apiHost}/v1/quotation/send-email`,
      data
    );
  }
}
